import React from 'react';
import ArtStage from '../../../ArtStage';
import CentralColumn from '../CentralColumn';
import cn from 'classnames';
import Details from '../../../DeviationViews/Details';
import Comments from '../Comments';
import TextualContent from '../../../DeviationViews/TextualContent/TextualContent';
import ActionBar from '../../../ActionBar';
import s from './StashPageContent.scss';
const StashPageContent = ({ deviation })=>{
    return /*#__PURE__*/ React.createElement("div", {
        className: cn(s['root'])
    }, /*#__PURE__*/ React.createElement("div", {
        className: cn(s['left-column'], s['stage'])
    }, /*#__PURE__*/ React.createElement(ArtStage, {
        deviation: deviation
    }), /*#__PURE__*/ React.createElement(ActionBar, {
        deviation: deviation
    }), /*#__PURE__*/ React.createElement(CentralColumn, null, /*#__PURE__*/ React.createElement(TextualContent, {
        deviation: deviation
    }), /*#__PURE__*/ React.createElement(Details, {
        deviation: deviation
    }))), /*#__PURE__*/ React.createElement("div", {
        className: cn(s['left-column'], s['meta'])
    }, /*#__PURE__*/ React.createElement(CentralColumn, null, /*#__PURE__*/ React.createElement(Comments, {
        deviation: deviation,
        className: s['comments']
    }))));
};
StashPageContent.displayName = 'StashPageContent';
export default StashPageContent;
